















import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';
import ManageRuleParameter from '@/views/configuration/rule-configuration/manage-rule-parameter.vue';
import RuleGroup from '@/domain/scripts/entity/rule-group.entity';

@Component({
  components: {
    MainButton, ManageRuleParameter,
  },
})
export default class ManagementEditionParameters extends Vue {
  @Prop() businessUnitId!: string;

  @Prop() isAdministrator!: boolean;

  @Prop() isEditMode!: boolean;

  @Prop() previewModeValue!: boolean;

  @Prop() ruleGroup!: RuleGroup;

  updateParameters() {
    this.update();
  }

  @Emit('updateRuleParameter')
  update() {
    return this.ruleGroup;
  }
}
